import React from "react";
import "./BlogCard.css";

const BlogCard = ({ blog }) => {
  return (
    <div className="blog-card">
      <img src={blog.image} alt={blog.title} />
      <div className="blog-info">
        <p>{blog.date} — <span>{blog.category}</span></p>
        <h3>{blog.title}</h3>
        <a href="/#">Daha Fazla →</a>
      </div>
    </div>
  );
};

export default BlogCard;
